import DefaultRenderer from './default';
import Swiper from 'swiper';

class careers extends DefaultRenderer {
	onEnter() {
		super.onEnter();

		let offerSlider = new Swiper('.what-we-offer-slider', {
			init: false,
			slidesPerView: 1,
			spaceBetween: 20,
			centeredSlides: true,
			breakpoints: {
				// when window width is <= 480px
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
			grabCursor: true,
			// freeMode: true,
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});

		let quoteSlider = new Swiper('.quote-slider', {
			init: false,
			slidesPerView: 1,
			loop: true,
			effect: 'fade',
			draggable: false,
			fadeEffect: {
				crossFade: true,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			observer: true,
			speed: 800,
			autoplay: {
				delay: 5000,
			},
			observeParents: true,
			observeSlideChildren: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});

		offerSlider.init();
		quoteSlider.init();
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default careers;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/careers.js